import { Termin } from '@/domain/termine/shared/types/Termin';
import { faEdit, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@/components/ui/button';
import { TerminInfo } from '@/domain/termine/features/Calendar/shared/TerminInfo/TerminInfo';
import { useDayPopover } from '@/domain/termine/features/Calendar/Grid/DayCell/Popover/DayPopoverContext';

export function TerminPopoverContent({ termin }: { termin: Termin }) {
  const fromDayPopover = useDayPopover();

  return (
    <div
      className={`w-[340px] bg-white shadow-lg p-5 rounded-lg ${
        fromDayPopover ? 'translate-x-[15px]' : ''
      }`}>
      <TerminInfo termin={termin} />
      <div className="flex justify-end items-center gap-3 mt-5">
        <Button size="sm" variant="ghost" className="focus-visible:ring-0">
          <FontAwesomeIcon
            className="text-primary-red-R400"
            icon={faTrashCan}
          />
        </Button>
        <Button size="sm" variant="ghost">
          <FontAwesomeIcon className="text-primary-blue-B600" icon={faEdit} />
        </Button>
      </div>
    </div>
  );
}
